import { useState } from "react";
import { motion } from "framer-motion";
import PageTransition from "./Pagetransition";
import { RevealBox, SectionLabel, SectionTitle, Divider } from "./Sectioncomponents";

const WA = "542236901020";

const fieldStyle = {
  width: "100%",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(201,151,58,0.2)",
  color: "#f9f5ef",
  padding: "1rem 1.2rem",
  fontFamily: "'Jost', sans-serif",
  fontSize: "0.85rem", fontWeight: 300,
  outline: "none",
  transition: "border-color 0.3s, background 0.3s",
  resize: "none",
};

function Field({ id, label, type = "text", placeholder, rows }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
      <label style={{
        color: "#c9973a", fontFamily: "'Jost', sans-serif",
        fontSize: "0.65rem", letterSpacing: "0.3em", textTransform: "uppercase",
      }}>
        {label}
      </label>
      {rows ? (
        <textarea id={id} placeholder={placeholder} rows={rows} style={fieldStyle}
          onFocus={(e) => { e.target.style.borderColor = "rgba(201,151,58,0.6)"; e.target.style.background = "rgba(201,151,58,0.04)"; }}
          onBlur={(e)  => { e.target.style.borderColor = "rgba(201,151,58,0.2)"; e.target.style.background = "rgba(255,255,255,0.04)"; }}
        />
      ) : (
        <input id={id} type={type} placeholder={placeholder} style={fieldStyle}
          onFocus={(e) => { e.target.style.borderColor = "rgba(201,151,58,0.6)"; e.target.style.background = "rgba(201,151,58,0.04)"; }}
          onBlur={(e)  => { e.target.style.borderColor = "rgba(201,151,58,0.2)"; e.target.style.background = "rgba(255,255,255,0.04)"; }}
        />
      )}
    </div>
  );
}

export default function ContactoPage() {
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    const nombre = document.getElementById("c-nombre")?.value.trim();
    const tel    = document.getElementById("c-tel")?.value.trim();
    const msg    = document.getElementById("c-msg")?.value.trim();
    if (!nombre) { alert("Por favor ingresá tu nombre."); return; }
    const text = `Hola Monaco Aberturas! Soy *${nombre}*${tel ? `, mi teléfono es ${tel}` : ""}. ${msg || "Me gustaría consultar sobre sus productos y precios."}`;
    window.open(`https://wa.me/${WA}?text=${encodeURIComponent(text)}`, "_blank");
    setSent(true);
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <PageTransition>
      <div style={{
        minHeight: "100vh", paddingTop: "8rem", paddingBottom: "6rem",
        position: "relative", overflow: "hidden", textAlign: "center",
        background: "linear-gradient(135deg, #0f0d0b 0%, #1a1510 100%)",
      }}>
        {/* Glow */}
        <div style={{
          position: "absolute", width: 600, height: 600, borderRadius: "50%",
          background: "radial-gradient(circle, rgba(184,74,46,0.12) 0%, transparent 70%)",
          top: "50%", left: "50%", transform: "translate(-50%,-50%)",
          pointerEvents: "none",
        }} />

        <div style={{ maxWidth: 600, margin: "0 auto", padding: "0 2rem", position: "relative", zIndex: 2 }}>
          <RevealBox><SectionLabel style={{ justifyContent: "center" }}>Contacto directo</SectionLabel></RevealBox>
          <RevealBox delay={0.1}>
            <SectionTitle style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>
              ¿Listo para <em>transformar</em><br/>tu espacio?
            </SectionTitle>
          </RevealBox>
          <RevealBox delay={0.2}>
            <p style={{
              fontFamily: "'Jost', sans-serif", fontWeight: 300,
              fontSize: "1rem", lineHeight: 1.9,
              color: "rgba(249,245,239,0.65)", maxWidth: 560, margin: "0 auto 3rem",
            }}>
              Contactanos hoy mismo y recibí asesoramiento personalizado sin cargo. Presupuestamos sin compromiso.
            </p>
          </RevealBox>

          {/* WhatsApp big button */}
          <RevealBox delay={0.25}>
            <motion.a
              href={`https://wa.me/${WA}?text=${encodeURIComponent("Hola Monaco Aberturas! Me gustaría consultar sobre sus productos y precios.")}`}
              target="_blank" rel="noreferrer"
              whileHover={{ y: -3, boxShadow: "0 20px 50px rgba(37,211,102,0.35)" }}
              whileTap={{ scale: 0.97 }}
              style={{
                display: "inline-flex", alignItems: "center", gap: "1rem",
                background: "#25D366", color: "white",
                padding: "1.2rem 3rem",
                fontFamily: "'Jost', sans-serif",
                fontSize: "0.9rem", fontWeight: 600,
                letterSpacing: "0.15em", textTransform: "uppercase",
                textDecoration: "none", cursor: "none",
              }}
            >
              <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: 26, height: 26 }}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              <span>Contactar por WhatsApp · 2236 901020</span>
            </motion.a>
          </RevealBox>

          {/* Divider */}
          <RevealBox delay={0.3}>
            <div style={{
              display: "flex", alignItems: "center", gap: "2rem",
              justifyContent: "center", margin: "2.5rem 0",
              color: "rgba(201,151,58,0.4)",
              fontFamily: "'Jost', sans-serif",
              fontSize: "0.75rem", letterSpacing: "0.3em", textTransform: "uppercase",
            }}>
              <span style={{ flex: 1, maxWidth: 100, height: 1, background: "rgba(201,151,58,0.25)", display: "block" }} />
              o dejanos un mensaje
              <span style={{ flex: 1, maxWidth: 100, height: 1, background: "rgba(201,151,58,0.25)", display: "block" }} />
            </div>
          </RevealBox>

          {/* Form */}
          <RevealBox delay={0.35}>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem", textAlign: "left" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                <Field id="c-nombre" label="Nombre"   placeholder="Tu nombre"   />
                <Field id="c-tel"    label="Teléfono" placeholder="Tu teléfono" type="tel" />
              </div>
              <Field id="c-email" label="Email"   placeholder="Tu email (opcional)" type="email" />
              <Field id="c-msg"   label="Mensaje" placeholder="Contanos sobre tu proyecto..." rows={4} />

              <motion.button
                onClick={handleSubmit}
                whileHover={{ backgroundColor: "#c9973a", color: "#1a1814" }}
                whileTap={{ scale: 0.97 }}
                style={{
                  alignSelf: "center",
                  padding: "1rem 3rem",
                  border: "1px solid #c9973a",
                  color: "#f0c96b",
                  background: "transparent",
                  fontFamily: "'Jost', sans-serif",
                  fontSize: "0.8rem", fontWeight: 500,
                  letterSpacing: "0.25em", textTransform: "uppercase",
                  cursor: "none",
                  transition: "background 0.3s, color 0.3s",
                }}
              >
                {sent ? "✓ Abriendo WhatsApp..." : "Enviar consulta"}
              </motion.button>
            </div>
          </RevealBox>
        </div>
      </div>
    </PageTransition>
  );
}